import ColorSelectorInput from './ColorSelectorInput';

export default ColorSelectorInput;
